import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import "./style.css";

interface EscalationItem {
  auditQuestion: string;
  status: string;
  description: string;
  resolutionTime: string;
}

interface EscalationDetailsProps {
  escalations: EscalationItem[];
  escalationscount: "";
}

const EscalationDetailsCard: React.FC<EscalationDetailsProps> = ({ escalations, escalationscount }) => {
  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case "in progress":
        return " #FFD97D";
      case "resolved":
        return "#15A96D"; // Green
      case "open":
        return " #FFD97D"; // Blue
      default:
        return "#6c757d"; // Gray
    }
  };

  return (
    <div style={{ maxHeight: "500px", overflowY: "auto", paddingRight: "10px" }}>
      <div className="header-row">
        <h6 className="section-title">Escalations</h6>
      </div>
      <div className="header-row">
        <h6 className="totalescalation">Total Escalations : &nbsp; {escalationscount}</h6>
      </div>
      <Row className="g-3">
        {escalations.map((escalation, index) => (
          <Col md={4} key={index}>
            <Card className="shadow-sm general-audit-card h-100">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start">
                  <h6 className="fw-bold mb-0 title">{escalation.auditQuestion}</h6>
                  <div className="d-flex align-items-center gap-1 bg-white px-2 py-1 rounded">
                    <span
                      className="status-dot"
                      style={{
                        backgroundColor: getStatusColor(escalation.status),
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        display: "inline-block",
                      }}
                    />
                    <span className="text-dark" style={{ fontSize: "0.875rem", fontWeight: 500, textWrap: "nowrap" }}>
                      {escalation.status}
                    </span>
                  </div>
                </div>

                <table className="w-100 no-border-table">
                  {/* This thead has been added to fix a SonarQube vulnerability. 
                        As per the SonarQube syntax no table should exist without the thead and row scope Since it is visually hidden, it will not affect the screen.  */}
                  <thead className="visually-hidden">
                    <tr>
                      <th>Column 1</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan={2} className="Descriptionvalue">
                        {escalation.description}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Average Resolution Time:</td>
                      <td className="Descriptionvalue">
                        <strong>{escalation.resolutionTime}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>

  );
};

export default EscalationDetailsCard;
